<template>
  <div class="switch_pin_type">
    <div
      :class="['switch_pin_type-button', {'is-current': includesSpotsPin}]"
      @click="switchVisualizationPinType('spots')"
    >
      <icon-spot width="45px" height="45px" />
      <span class="switch_pin_type-label">
        場所
      </span>
    </div>

    <div
      :class="['switch_pin_type-button', {'is-current': includesPersonsPin}]"
      @click="switchVisualizationPinType('persons')"
    >
      <icon-person width="45px" height="45px" />
      <span class="switch_pin_type-label switch_pin_type-label--person">
        人
      </span>
    </div>
  </div>
</template>

<script>
import iconSpot from './icons/spot.vue';
import iconPerson from './icons/person.vue';

export default {
  components: {
    iconSpot,
    iconPerson,
  },
  computed: {
    visualizationPinType: {
      get: ({ $store }) => $store.state.map.visualizationPinType,
      set(value) {
        this.$store.commit('map/switchVisualizationPinType', value);
      },
    },
    includesSpotsPin: ({ $store }) => $store.getters['map/includesSpotsPin'],
    includesPersonsPin: ({ $store }) => $store.getters['map/includesPersonsPin'],
  },
  methods: {
    switchVisualizationPinType(value) {
      this.visualizationPinType = value;
    },
  },
};
</script>

<style scoped lang="scss">
.switch_pin_type {
  margin-top: 13px;
  margin-bottom: 30px;
  &-button {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid #9d9d9d;
    border-radius: 33px;
    margin-bottom: 10px;
    padding-left: 17px;
    height: 66px;
    width: 140px;
    background: #fff;
    line-height: 1;
    font-size: 26px;
    font-weight: bold;
    color: #9d9d9d;
    &.is-current {
      border-color: #0174bf;
      border-width: 2px;
      color: #0174bf;
    }
  }
  &-label {
    margin-left: 9px;
    &--person {
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// switch_pin_type.vue?7cdb8a68